/** 引入Vue 库 */
import Vue from 'vue'

/** 引入index.vue */
import IndexVue from "./pages/index"

/** 引入路由配置文件 */
import router from './router/index'

/** 引入element-ui文件并注册 */
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

/** 全局组件 */
import global from './components/index';
Vue.use(global)

/** 引入apis */
import Api from './api/index'
Vue.prototype.$Api = Api

// import '@/assets/icon/iconfont.css'
/** 引入index.less */
import '@/styles/main'

/** 内容管理：所有页面的文字/图片/视频/数据均可由后台配置，服务不可用时自动回落默认内容 */
import CmsPlugin from '@/cms'
Vue.use(CmsPlugin)

import "default-passive-events"; //添加事件管理者'passive'，来阻止'touchstart'事件，让页面更加流畅。 解决chrome下的warning问题

var baseUrl = 'https://audio.kbsdkj.cn'
Vue.prototype.$baseUrl = baseUrl

var wsUrl = 'wss://audio.kbsdkj.cn'
Vue.prototype.$wsUrl = wsUrl

// 6144*2304、7680*2160
const width = 7680
const height = 2160
// const width = 6144
// const height = 2304
Vue.prototype.$width = width
Vue.prototype.$height = height

new Vue({
    el: '#app', 
    render(createElement) {
        let layout = this.$route.meta.layout
        layout = layout ? layout : this.$route.path === '/' ? '' : 'main-layout';
        return createElement(IndexVue, {props: {layout}})
    },
    router,
})

